import { Box } from '@material-ui/core';
import React from 'react';
import styles from './SGSStack.module.scss';

type Props = React.PropsWithChildren<{}>;

/** Permet d'aligner plus facilement les champs d'un formulaire */
const SGSStack: React.FC<Props> = ({ children }) => {
    return (
        <Box display="flex" flexDirection="column" className={styles.root}>
            {children}
        </Box>
    );
};

export default SGSStack;
